import { Button, CircularProgress } from "@mui/material";
import Container from "@mui/material/Container";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { BASE_HOME } from "../../common/baseUrl";
import { PATH_ESEWA_PAYMENT, PAYMENT_ESEWA, PAYMENT_KHALTI } from "../../common/constants";
import { getKhalti } from './khalti_utils.js'

interface PaymentPram {
    amount: string
    deliveryCharge: string
    orderId: string
    paymentCode: string
    serviceCharge: string
    token: string
    txAmount: string
}

interface EsewaPrams {
    amt: string,
    psc: string,
    pdc: string,
    txAmt: string,
    tAmt: string,
    pid: string,
    scd: "EPAYTEST"|"NP-ES-FOODMOOD",
    su: string,
    fu: string
}

const getEsewaPrams = (prams: PaymentPram): EsewaPrams => {



    let totaln = parseFloat(prams.amount) + parseFloat(prams.txAmount) + parseFloat(prams.deliveryCharge) + parseFloat(prams.serviceCharge)

    let total= totaln.toFixed(2)
    
    const routeS = `${BASE_HOME}/postpayment/t/${prams.token}/o/${prams.orderId}/p/${prams.paymentCode}/i/${total}/s/1`

    const routeF = `${BASE_HOME}/postpayment/t/${prams.token}/o/${prams.orderId}/p/${prams.paymentCode}/i/${total}/s/2`

    return {
        amt: prams.amount,
        psc:prams.serviceCharge,
        pdc: prams.deliveryCharge,
        txAmt:prams.txAmount,
        tAmt: `${total}`,
        pid: prams.orderId,
        scd: "NP-ES-FOODMOOD",
        su: routeS,
        fu: routeF
    }

}

const PaymentPage: React.FC = () => {

    const params = useParams() as PaymentPram;

    console.log(params.paymentCode);

    const history = useHistory();

    useEffect(() => {
        if (params.paymentCode === PAYMENT_ESEWA) {

            let esewaPrams = getEsewaPrams(params);
            console.log('prams',esewaPrams)
            var form = document.createElement("form");
            form.setAttribute("method", "POST");
            form.setAttribute("action", PATH_ESEWA_PAYMENT);

            for (var key in esewaPrams) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", (esewaPrams as any)[key]);
                form.appendChild(hiddenField);
            }

            document.body.appendChild(form);
            form.submit();
        } else if (params.paymentCode === PAYMENT_KHALTI) {

            let total = parseFloat(params.amount) + parseFloat(params.txAmount) + parseFloat(params.deliveryCharge) + parseFloat(params.serviceCharge)
            total = total * 100;
            const routeS = `/postpayment/t/${params.token}/o/${params.orderId}/p/${params.paymentCode}/i/${total}/s/1`

            const routeF = `/postpayment/t/${params.token}/o/${params.orderId}/p/${params.paymentCode}/i/${total}/s/2`

            let config = {
                // replace this key with yours
                "publicKey": "test_public_key_dc74e0fd57cb46cd93832aee0a390234",
                "productIdentity": params.orderId,
                "productName": "Foodmood",
                "productUrl": "https://foodmood.com.np",
                "eventHandler": {
                    onSuccess(payload: any) {
                        // hit merchant api for initiating verfication
                        console.log(payload);
                        /**
                         * 
                         *  "idx": "8xmeJnNXfoVjCvGcZiiGe7",
                            "amount": 1000,
                            "mobile": "98XXXXX969",
                            "product_identity": "1234567890",
                            "product_name": "Dragon",
                            "product_url": "http://gameofthrones.wikia.com/wiki/Dragons",
                            "token": "QUao9cqFzxPgvWJNi9aKac"
                         */
                        history.push(`${routeS}?oid=${payload.product_identity}&amt=${payload.amount}&refId=${payload.idx}&ptoken=${payload.token}`);

                    },
                    // onError handler is optional
                    onError(error: any) {
                        // handle errors
                        console.log(error);
                        history.push(`${routeF}?err=${error.detail}`);
                    },
                    onClose() {
                        console.log('widget is closing');
                        // if(khalti){
                        //     khalti.show({amount:total})
                        // }
                        // history.push(routeS);

                    }
                },
                "paymentPreference": ["KHALTI", "EBANKING", "MOBILE_BANKING", "CONNECT_IPS", "SCT"],
            };
            const khalti = getKhalti(config)
            khalti.show({ amount: total })


        }

    }, [params.paymentCode])

    if (params.paymentCode === PAYMENT_ESEWA) {
        return (
            <>
                <Container maxWidth={'sm'} sx={{ display: 'flex', height: '90vh', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </Container>
            </>
        )
    }

    if (params.paymentCode === PAYMENT_KHALTI) {



        return (
            <>
                <Container>

                </Container>
            </>
        )
    }

    return (
        <>
            Payment
        </>
    )
}

export default PaymentPage;